import { durationDays, isValidDate } from './dateTime';
import { isNotEmpty } from './queries';
import { WorkPatternItemDto } from 'api/generated';
import moment from 'moment';
import pluralize from 'pluralize';

export function formatDurationDate(
  start: string | Date | undefined,
  end: string | Date | undefined,
  pattern: WorkPatternItemDto[]
) {
  const days = durationDays(start, end, pattern);
  return pluralize('day', days, true);
}

export function formatDate(date: string | Date, format: string = 'DD/MM/YYYY') {
  return moment(date).format(format).toLocaleLowerCase(); // may be unsafe
}

export function formatDatePlain(date: string | Date, format: string = 'YYYY-MM-DDTHH:mm:ss.SSS'): string {
  return moment(date).format(format).toUpperCase() + 'Z';
}

export function formatDateSafe(
  date: string | Date | undefined | null,
  format: string = 'DD/MM/YYYY',
  defaultValue: string = 'n/a'
) {
  if (!date) {
    return defaultValue;
  }
  return isValidDate(date) ? formatDate(date!, format) : defaultValue;
}

export function formatValueSafe(
  value: string | number | undefined | null,
  prefix: string = '',
  postfix: string = '',
  defaultValue: string = 'n/a'
) {
  if (!isNotEmpty(value)) {
    return defaultValue;
  }

  return `${prefix} ${value?.toString()} ${postfix}`.trim();
}

export function formatCurrencySafe(value: number | null | undefined, defaultValue: string = 'n/a') {
  if (!isNotEmpty(value)) {
    return defaultValue;
  }

  const currency = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'GBP'
  });

  return currency.format(value!);
}

export function formatRange(
  startDateTime: string | Date | undefined,
  endDateTime: string | Date | undefined,
  separator: string = '-'
) {
  if (!isValidDate(startDateTime) || !isValidDate(endDateTime)) {
    return '';
  }
  const dateFormat = 'ddd, DD/MM/YYYY';
  return `${formatDateSafe(startDateTime, dateFormat)} ${separator} ${formatDateSafe(endDateTime, dateFormat)}`;
}

export function transformFormat(
  date: string | Date,
  inFormat: string = 'DD/MM/YYYY',
  outFormat: string = 'YYYY/MM/DD'
) {
  return moment(date, inFormat).format(outFormat);
}
